export enum ChangeOrderType {
    JIO = 0,
    Plan = 1,
    Elevation = 2,
    Handing = 3,
    ChoiceAttribute = 4,
    HomesiteTransfer = 5,
    NonStandardOption = 6,
    Cancellation = 7,
    SpecJIO = 8,
    BuyerChangeOrder = 9,
    PriceAdjustment = 10,
    SalesNotes = 11
}
